/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GrdfConnectionConfigList } from '../../models/grdf-connection-config-list';

export interface ListGrdfConnectionConfigurations$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;
}

export function listGrdfConnectionConfigurations(http: HttpClient, rootUrl: string, params: ListGrdfConnectionConfigurations$Params, context?: HttpContext): Observable<StrictHttpResponse<GrdfConnectionConfigList>> {
  const rb = new RequestBuilder(rootUrl, listGrdfConnectionConfigurations.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GrdfConnectionConfigList>;
    })
  );
}

listGrdfConnectionConfigurations.PATH = '/stations/{uid}/grdf';
